
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

export default function TravelSection() {
  const { t } = useTranslation('common');

  return (
    <section id="travel" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-5xl font-bold text-gray-900 mb-4">
            {t('services.travel.title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {t('services.travel.desc')}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="group cursor-pointer"
          >
            <div className="w-full h-80 rounded-2xl overflow-hidden mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/720e0e3584000807b0e6ddace93ed104.jpg"
                alt="KL Tour"
                className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
            </div>
            <h3 className="text-2xl font-semibold text-gray-900 mb-2">KL周辺ツアー</h3>
            <p className="text-gray-600">クアラルンプール市内観光、ペトロナスツインタワー、バトゥ洞窟など人気スポットをご案内</p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="group cursor-pointer"
          >
            <div className="w-full h-80 rounded-2xl overflow-hidden mb-4">
              <img
                src="https://readdy.ai/api/search-image?query=historic%20Malacca%20city%20with%20colonial%20architecture%20colorful%20buildings%20traditional%20shophouses%20and%20cultural%20heritage%20sites%20featuring%20vibrant%20streets%20UNESCO%20world%20heritage%20charm%20and%20Malaysian%20historical%20atmosphere&width=600&height=500&seq=malacca-tour-001&orientation=landscape"
                alt="Malacca Tour"
                className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
            </div>
            <h3 className="text-2xl font-semibold text-gray-900 mb-2">マラッカツアー</h3>
            <p className="text-gray-600">世界遺産の古都マラッカで歴史と文化を体験。オランダ広場、ジョンカーストリートなど</p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="group cursor-pointer"
          >
            <div className="w-full h-80 rounded-2xl overflow-hidden mb-4">
              <img
                src="https://readdy.ai/api/search-image?query=beautiful%20Langkawi%20island%20tropical%20paradise%20with%20pristine%20white%20sand%20beaches%20crystal%20clear%20turquoise%20water%20palm%20trees%20and%20stunning%20coastal%20scenery%20featuring%20sunny%20weather%20natural%20beauty%20and%20relaxing%20vacation%20atmosphere&width=600&height=500&seq=langkawi-tour-001&orientation=landscape"
                alt="Langkawi Tour"
                className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
            </div>
            <h3 className="text-2xl font-semibold text-gray-900 mb-2">ランカウィ島案内</h3>
            <p className="text-gray-600">美しいビーチリゾート、スカイブリッジ、マングローブツアーなど自然を満喫</p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
